import React from "react";
import { RCCIcon } from "react-common-components";
import GaugeChart from "src/components/GaugeChart";
import { useTranslation } from "src/context/Translations/context";
import formatNumber from "src/utils/formatNumber";
import { ITooltipIndicator } from "./interface";
import * as Tooltip from "./styles";

const TooltipIndicators: React.FC<ITooltipIndicator> = ({
	value,
	styleInline,
	onClick
}) => {
	const { translate, currentLanguage } = useTranslation();

	if(!value)
		return null;

	return(
		<Tooltip.Container styleInline={styleInline} onClick={onClick}>
			<Tooltip.Title>
				<span>
					{value.isDisabled && `(${translate("Desabilitado")})`} {!value.hasValue && `(${translate("Sem valor")})`} {value.label}
					<RCCIcon
						name={value.iqc001Formaaval === 0 ? "arrowDown" : "arrowUp"}
						size={24}
						color="var(--default-color-font)"
						style={{
							border: "2px solid var(--default-color-font)",
							borderRadius: "50%"
						}}
					/>
				</span>
				{value.title && (
					<span>{value.title} </span>
				)}
			</Tooltip.Title>
			<Tooltip.Line>
				<span>{value.labelGoal !== null && value.labelGoal !== "" ? value.labelGoal : translate("Meta")}:</span>
				<span>{formatNumber(value.goal, currentLanguage, value.decimalPlaces)}</span>
			</Tooltip.Line>
			<Tooltip.Line>
				<span>{value.labelCompareGoal !== null && value.labelCompareGoal !== "" ? value.labelCompareGoal : translate("Valor")}:</span>
				<span>{formatNumber(value.value, currentLanguage, value.decimalPlaces)}</span>
			</Tooltip.Line>
			<div style={{position: "relative"}}>
				<GaugeChart 
					max={value.metrics.maxValue}
					min={0}
					value={value.percentage}
					label=" "
					color={value.metrics.metricRanges.length > 0 ? value.metrics.metricRanges : value.color ?? undefined}
				/>	
				<Tooltip.Circle color={value.color === null ? undefined : `#${value.color}`} />		
			</div>
			{!value.isDisabled && !value.hasFca && value.fcaAbsent && (
				<Tooltip.LineFCA>
					<RCCIcon 
						color="var(--orange)"
						name="exclamationCircle"
						size={12}
					/>
					{translate("Análise FCA pendente")}
				</Tooltip.LineFCA>
			)}
			{!value.isDisabled && value.hasFca && (
				<Tooltip.LineFCA isGreen>
					<RCCIcon 
						color="var(--green)"
						name="exclamationCircle"
						size={12}
					/>
					{translate("Análise FCA realizada")}
				</Tooltip.LineFCA>
			)}
		</Tooltip.Container>
	);};

export default TooltipIndicators;
